// extracted by mini-css-extract-plugin
export default {"switchContainer":"UsersAdminTable_switchContainer__x-yho","rowContainer":"UsersAdminTable_rowContainer__tbCyG"};